module.exports = require("node:process");